import { Pagination } from 'antd';
import React from 'react';
import useWindowSize from 'src/hooks/useWindowSize';

interface Props {
  pageNumber: number;
  total: number;
  pageSize: number;
  handleChangePage: (pageNumber: number, pageSize: number) => void;
  length: number;
  optionType: boolean;
}
const ListPagination: React.FC<Props> = (props) => {
  const startIndex = (props.pageNumber - 1) * props.pageSize + 1;
  const endIndex = (props.pageNumber - 1) * props.pageSize + props.length;
  const pageSizeOptions = ['10', '20', '50', '100'];
  const size = useWindowSize();
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  props?.optionType ? pageSizeOptions.unshift('5') : pageSizeOptions;
  return (
    <div className='listing-paging-box flex gap-x-2 justify-between py-4 items-center'>
      <div className='d-md-block d-none w-fit' style={{ color: '#AFAFAF', fontSize: 12 }}>
        {`${endIndex ? startIndex : 0} - ${endIndex} trong ${props.total} bản ghi`}
      </div>
      <Pagination
        size={size.width <= 768 ? 'small' : 'default'}
        showSizeChanger={true}
        onChange={(pageNumber, pageSize) => {
          props.handleChangePage(pageNumber, pageSize);
        }}
        current={props.pageNumber}
        total={props.total}
        pageSize={props.pageSize ?? 10}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default ListPagination;
